import { scrollToElement } from '../functions/lenis-scroll';

export const Navbar = () => {
    const header = document.querySelector('.header');
    const headerMenuBtn = document.getElementById('menuBtn');

    if (!header || !headerMenuBtn) {
        return;
    }

    const headerMenuLines = headerMenuBtn.querySelectorAll('span');
    const headerMenuMobile = document.querySelector('.js-header-menu-mobile');
    const headerInner = document.querySelector('.header-inner');
    const baseDesktopClasses = [
        'lg:py-5',
        'lg:-mt-24',
        'lg:bg-transparent',
        'lg:shadow-none',
        '!max-w-none',
    ];
    const scrolledDesktopClasses = [
        'lg:py-3',
        'lg:mt-0',
        'lg:bg-neutral-900/95',
        'lg:shadow-xl',
        '!max-w-none',
    ];
    const baseInnerDesktopClasses = ['lg:mt-12'];
    const scrolledInnerDesktopClasses = ['lg:mt-0'];
    const hiddenDesktopClass = 'lg:-translate-y-full';
    const hiddenMobileClass = 'max-lg:-translate-y-full';
    const desktopQuery = window.matchMedia('(min-width: 1024px)');
    const scrolledThreshold = 40;
    const hideThreshold = 20;
    const mobileMenuCloseDelay = 400;
    const mobileMenuAnchorOffset = 80;
    let lastScrollPosition = window.scrollY;
    let isScrolled = false;

    const setScrolledState = active => {
        if (active && !isScrolled) {
            header.classList.remove(...baseDesktopClasses);
            header.classList.add(...scrolledDesktopClasses);
            if (headerInner) {
                headerInner.classList.remove(...baseInnerDesktopClasses);
                headerInner.classList.add(...scrolledInnerDesktopClasses);
            }
            isScrolled = true;
        } else if (!active && isScrolled) {
            header.classList.remove(...scrolledDesktopClasses);
            header.classList.add(...baseDesktopClasses);
            if (headerInner) {
                headerInner.classList.remove(...scrolledInnerDesktopClasses);
                headerInner.classList.add(...baseInnerDesktopClasses);
            }
            isScrolled = false;
        }
    };

    const updateHeaderVisibility = scrollPos => {
        const mobileMenuOpen =
            headerMenuMobile &&
            headerMenuMobile.classList.contains('menu-open');

        if (!desktopQuery.matches) {
            header.classList.remove(hiddenDesktopClass);
            if (mobileMenuOpen) {
                header.classList.remove(hiddenMobileClass);
                return;
            }
        } else {
            header.classList.remove(hiddenMobileClass);
        }

        const isScrollingDown = scrollPos > lastScrollPosition;
        const canHideHeader = scrollPos > hideThreshold;

        if (isScrollingDown && canHideHeader) {
            if (desktopQuery.matches) {
                header.classList.add(hiddenDesktopClass);
            } else {
                header.classList.add(hiddenMobileClass);
            }
        } else {
            header.classList.remove(hiddenDesktopClass);
            header.classList.remove(hiddenMobileClass);
        }
    };

    const handleScroll = () => {
        const scrollPos = window.scrollY;

        setScrolledState(scrollPos >= scrolledThreshold);
        updateHeaderVisibility(scrollPos);

        lastScrollPosition = scrollPos <= 0 ? 0 : scrollPos;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    const syncDesktopState = () => {
        header.classList.remove(hiddenDesktopClass);
        header.classList.remove(hiddenMobileClass);
        if (!desktopQuery.matches) {
            header.classList.remove(...scrolledDesktopClasses);
            header.classList.add(...baseDesktopClasses);
            isScrolled = false;
            if (headerInner) {
                headerInner.classList.remove(...scrolledInnerDesktopClasses);
                headerInner.classList.add(...baseInnerDesktopClasses);
            }
        }
        lastScrollPosition = window.scrollY;
        handleScroll();
    };

    if (typeof desktopQuery.addEventListener === 'function') {
        desktopQuery.addEventListener('change', syncDesktopState);
    } else if (typeof desktopQuery.addListener === 'function') {
        desktopQuery.addListener(syncDesktopState);
    }

    const scrollToHashWithOffset = hash => {
        if (!hash) {
            return false;
        }

        const hashId = decodeURIComponent(hash.slice(1));
        const targetElement =
            document.getElementById(hashId) || document.querySelector(hash);

        if (!targetElement) {
            return false;
        }

        scrollToElement(targetElement, mobileMenuAnchorOffset);

        return true;
    };

    const getSamePageHashFromHref = href => {
        if (!href) {
            return null;
        }

        let url;

        try {
            url = new URL(href, window.location.href);
        } catch {
            return null;
        }

        const isSamePageAnchor =
            Boolean(url.hash) &&
            url.origin === window.location.origin &&
            url.pathname === window.location.pathname;

        return isSamePageAnchor ? url.hash : null;
    };

    handleScroll();

    const desktopMenuLinks = header.querySelectorAll('.lg\\:block a[href]');

    desktopMenuLinks.forEach(link => {
        link.addEventListener('click', event => {
            const hash = getSamePageHashFromHref(link.getAttribute('href'));

            if (!hash) {
                return;
            }

            event.preventDefault();
            scrollToHashWithOffset(hash);
        });
    });

    if (headerMenuMobile) {
        const transformations = [
            ['rotate-45', 'translate-y-[6px]'],
            ['opacity-0'],
            ['-rotate-45', '-translate-y-[6px]'],
        ];

        const setMobileButtonState = isOpen => {
            headerMenuLines.forEach((line, index) => {
                transformations[index].forEach(cls =>
                    line.classList.toggle(cls, isOpen)
                );
            });
        };

        const closeMobileMenu = () => {
            if (!headerMenuMobile.classList.contains('menu-open')) {
                return;
            }

            headerMenuMobile.classList.remove('menu-open');
            headerMenuMobile.classList.add('menu-closing');
            document.body.style.overflow = '';
            setMobileButtonState(false);

            setTimeout(() => {
                headerMenuMobile.classList.remove('menu-closing');
            }, mobileMenuCloseDelay);
        };

        const openMobileMenu = () => {
            headerMenuMobile.classList.add('menu-open');
            document.body.style.overflow = 'hidden';
            setMobileButtonState(true);
        };

        headerMenuBtn.addEventListener('click', () => {
            const isOpen = headerMenuMobile.classList.contains('menu-open');

            if (isOpen) {
                closeMobileMenu();
            } else {
                openMobileMenu();
            }
        });

        const mobileMenuLinks = headerMenuMobile.querySelectorAll('a[href]');

        mobileMenuLinks.forEach(link => {
            link.addEventListener('click', event => {
                const href = link.getAttribute('href');
                const hash = getSamePageHashFromHref(href);

                if (!href) {
                    closeMobileMenu();
                    return;
                }

                closeMobileMenu();

                if (hash) {
                    event.preventDefault();
                    window.setTimeout(() => {
                        scrollToHashWithOffset(hash);
                    }, 10);
                }
            });
        });
    }
};
